/* istanbul ignore file */
import { useToken } from '@ori/auth';
import { useServiceUrls } from '@ori/configuration-manager';
import { useEnvironment } from '@ori/environment';
import { SWRConfig } from '@ori/fetching';
import { ApiClientProvider as GlobalApiProvider } from '@ori/global-api-client-react';
import { useLanguage } from '@ori/i18n';
import { ApiClientProvider as StaticApiClientProvider } from '@ori/static-api-client-react';
import { swrConfig } from '../constants/swrConfig';
import { jsx as _jsx } from "react/jsx-runtime";
export const ApiProvider = ({
  children
}) => {
  const {
    language
  } = useLanguage();
  const {
    tenant
  } = useEnvironment();
  const {
    token
  } = useToken();
  const {
    staticApiUrl,
    globalApiUrl
  } = useServiceUrls(['staticApi', 'globalApi']);
  return /*#__PURE__*/_jsx(SWRConfig, {
    value: swrConfig,
    children: /*#__PURE__*/_jsx(GlobalApiProvider, {
      baseUrl: globalApiUrl,
      tenant: tenant,
      language: language,
      token: token,
      children: /*#__PURE__*/_jsx(StaticApiClientProvider, {
        baseUrl: staticApiUrl,
        language: language,
        tenant: tenant,
        children: children
      })
    })
  });
};
//# sourceMappingURL=ApiProvider.js.map